import { render, staticRenderFns } from "./SirenSearchBarLoading.vue?vue&type=template&id=778f7885&scoped=true&"
var script = {}
import style0 from "./SirenSearchBarLoading.vue?vue&type=style&index=0&id=778f7885&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f7885",
  null
  
)

export default component.exports